// Generated by purs version 0.15.0
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Delete = /* #__PURE__ */ (function () {
    function Delete() {

    };
    Delete.value = new Delete();
    return Delete;
})();
var Update = /* #__PURE__ */ (function () {
    function Update(value0) {
        this.value0 = value0;
    };
    Update.create = function (value0) {
        return new Update(value0);
    };
    return Update;
})();
var updateActionToMaybe = function (v) {
    if (v instanceof Delete) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Update) {
        return new Data_Maybe.Just(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Ids.UpdateAction (line 36, column 1 - line 36, column 59): " + [ v.constructor.name ]);
};
var genericEntityId = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Delete.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Update(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Ids.UpdateAction (line 15, column 1 - line 15, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Delete) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Update) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Ids.UpdateAction (line 15, column 1 - line 15, column 62): " + [ x.constructor.name ]);
    }
};
var showUpdateAction = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericEntityId)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "Delete";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))({
            reflectSymbol: function () {
                return "Update";
            }
        })))
    };
};
var udecodeUpdateAction = function (dictDecodeSingleConstructorArgument) {
    return {
        unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericEntityId)(Unscramble_Generic.genericDecode(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
            reflectSymbol: function () {
                return "Delete";
            }
        }))(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "Update";
            }
        })(dictDecodeSingleConstructorArgument))))(Unscramble_Generic.defaultOptions)
    };
};
var eqUpdateAction = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericEntityId)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq))))
    };
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeUpdateAction = function (dictGenericEncodeArgs) {
    return {
        encode: Foreign_Generic.genericEncode(genericEntityId)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "Delete";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "Update";
            }
        })(dictGenericEncodeArgs)))(encodingOpts)
    };
};
var decodeUpdateAction = function (dictGenericDecodeArgs) {
    return {
        decode: Foreign_Generic.genericDecode(genericEntityId)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "Delete";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "Update";
            }
        })(dictGenericDecodeArgs)(Foreign_Generic_Class.genericCountArgsArgument)))(encodingOpts)
    };
};
export {
    Delete,
    Update,
    encodingOpts,
    updateActionToMaybe,
    genericEntityId,
    showUpdateAction,
    eqUpdateAction,
    decodeUpdateAction,
    udecodeUpdateAction,
    encodeUpdateAction
};
//# sourceMappingURL=index.js.map
